const versionString = 'Conway Web-Ifc Shim v0.23.940';
export { versionString };
